export default {"src":"/_next/static/media/affar_indc.d239278d.svg","height":47,"width":119,"blurWidth":0,"blurHeight":0};